import { Component, OnInit } from "@angular/core";
import { AuthService } from "../../core/services/auth.service";
import { Router } from "@angular/router";
import { LoginUsuario } from "../../core/models/login-usuario";
import { TokenService } from "../../core/services/token.service";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { SweetAlertService } from "src/app/core/services/sweet-alert.service";
import { ListValueService } from "src/app/core/services/list-value.service";
import { CommonService } from "../../core/services/common.service";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { TranslateService } from "@ngx-translate/core";
import { AppConstants } from "src/app/constants/app.constants";
import * as moment from "moment";
import { FiltersTableStateService } from "src/app/core/services/filters-table-state.service";
import { FiltersTableJSON } from "src/app/core/models/filter-table-state.model";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  loginUsuario: LoginUsuario;
  nombreUsuario: string = "";
  password: string = "";
  initMessage: string;
  checked = false;
  public showPassword = true;

  constructor(
    private tokenService: TokenService,
    private authService: AuthService,
    private router: Router,
    private toastrAlertService: ToastrAlertService,
    private sweetAlertService: SweetAlertService,
    private commonService: CommonService,
    private translateService: TranslateService,
    private listValueService: ListValueService,
    private filtersTableStateService: FiltersTableStateService
  ) {}

  ngOnInit() {
    if (!this.tokenService.isLogged()) {
      this.getInitMessage();
    } else {
      this.router.navigate(["/"]);
    }
  }

  getInitMessage() {
    this.commonService.getInitMessage().subscribe(
      (data) => {
        let content = data["datos"];

        if (content.length > 0 && content[content.length - 1][1]) {
          this.initMessage = content[content.length - 1][1];
        }
      },
      (err) => {}
    );
  }

  validateForm(): boolean {
    if (this.nombreUsuario == "" && this.password == "") {
      let fields: string =
        this.translateService.instant("messages.fieldsError") +
        "<br/>" +
        this.translateService.instant("messages.fieldsRequired.userRequired") +
        "</br> " +
        this.translateService.instant("messages.fieldsRequired.passwdRequired");

      this.toastrAlertService.toastrFail(fields);
      return false;
    } else if (this.nombreUsuario == "") {
      let fields: string =
        this.translateService.instant("messages.fieldsError") +
        "<br/>" +
        this.translateService.instant("messages.fieldsRequired.userRequired");

      this.toastrAlertService.toastrFail(fields);
      return false;
    } else if (this.password == "") {
      let fields: string =
        this.translateService.instant("messages.fieldsError") +
        "<br/>" +
        this.translateService.instant("messages.fieldsRequired.passwdRequired");

      this.toastrAlertService.toastrFail(fields);
      return false;
    } else {
      return true;
    }
  }

  onLogin(): void {
    if (this.validateForm()) {
      this.loginUsuario = new LoginUsuario(this.nombreUsuario, this.password);
      this.authService.login(this.loginUsuario).subscribe(
        (data) => {
          this.translateService.setDefaultLang("es");
          this.translateService.use("es");
          this.tokenService.setToken(data.token);
          this.tokenService.setPersonalNumPages();
          this.clearPreviousFilters();

          if (this.tokenService.hasRole(AppConstants.roles.RHOMOLOG)) {
            this.validateIfHaveCertificate();
            this.validateCertificate();
          }

          if (
            this.tokenService.hasRole(AppConstants.roles.ADMIN) &&
            this.tokenService.validateExpiratedCertificate()
          ) {
            this.getCertificatesExpiredByRol();
          }

          if (this.tokenService.validateExpirationPassword()) {
            let message = this.translateService.instant(
              "messages.passwordExpired"
            );

            this.sweetAlertService.addStepsQueue(
              this.sweetAlertService.sweetAlertBasicReturn(message)
            );
            this.sweetAlertService.showSwalQueue();
            this.sweetAlertService.resetStepsQueue();
            this.router.navigate([RoutingConstants.changePassword.list]);
          }

          if (
            this.tokenService.hasRole(AppConstants.roles.ADMIN) &&
            !this.tokenService.validateExpiratedCertificate()
          ) {
            this.getCertificatesExpiredByRol();
          }

          if (
            !this.tokenService.hasRole(AppConstants.roles.ADMIN) &&
            !this.tokenService.validateExpirationPassword()
          ) {
            this.tokenService.redirectPredefinedMailBox();
          }
        },
        (err) => {
          let message: string = this.translateService.instant(
            "errorsInterceptor.network"
          );
          this.toastrAlertService.toastrFail(
            err.error?.mensaje ? err.error?.mensaje : message
          );
        }
      );
    }
  }

  private clearPreviousFilters() {
    const filtersEmpty = {
      filterList: [],
      filtersValuesSearch: [],
      filtersSelectorSearch: [],
    };
    this.filtersTableStateService.setPreviousValuesOfFilters(filtersEmpty);
    this.filtersTableStateService.setPreviousValuesOfFiltersOutTable(
      filtersEmpty
    );
    let filtersTableJSON: FiltersTableJSON = {
      asc: true,
      order: "",
      page: 0,
      size: 10,
      screenId: "",
    };
    this.filtersTableStateService.setFiltersTable(filtersTableJSON);
    this.filtersTableStateService.setFiltersTableHistory(filtersTableJSON);
  }

  getCertificatesExpiredByRol() {
    let usuarios =
      "Los siguientes usuarios tienen los certificados caducados: </br>";

    this.listValueService
      .certificatesExpiredByRole(AppConstants.roles.RHOMOLOG)
      .subscribe(
        (data) => {
          data.forEach((e) => {
            usuarios +=
              "Código de usuario: " +
              e.usId +
              ", fecha de caducidad: " +
              moment(e.usCaducidad).format("DD/MM/YY") +
              "</br>";
          });
          if (data.length > 0) {
            this.sweetAlertService.addStepsQueue(
              this.sweetAlertService.sweetAlertBasicReturn(usuarios)
            );
          }

          if (!this.tokenService.validateExpirationPassword()) {
            this.tokenService.redirectPredefinedMailBox();
          }
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }

  validateCertificate() {
    let validationExpirationNear =
      this.tokenService.validateExpirationNearlyCertificate();
    let validationExpirated = this.tokenService.validateExpiratedCertificate();

    if (
      this.tokenService.hasExpirationCertificate() &&
      validationExpirated.expired
    ) {
      let message = this.translateService.instant(
        "messages.expiratedCertificate"
      );
      let message2 = this.translateService.instant(
        "messages.expiratedCertificate2"
      );

      this.sweetAlertService.addStepsQueue(
        this.sweetAlertService.sweetAlertBasicReturn(
          message +
            validationExpirated.dateExpiration.format("DD/MM/YY") +
            message2
        )
      );
    } else if (
      this.tokenService.hasExpirationCertificate() &&
      !validationExpirationNear.expired
    ) {
      let message = this.translateService.instant(
        "messages.expirationCertificate"
      );

      this.sweetAlertService.addStepsQueue(
        this.sweetAlertService.sweetAlertBasicReturn(
          message + validationExpirationNear.dateExpiration.format("DD/MM/YY")
        )
      );
    }
  }

  validateIfHaveCertificate() {
    if (!this.tokenService.hasExpirationCertificate()) {
      let message = this.translateService.instant(
        "messages.dontHaveCertificate"
      );

      this.sweetAlertService.sweetAlertBasic(message);
    }
  }

  public changeView() {
    this.showPassword = !this.showPassword;
  }
}
